import * as React from 'react';
import { TextAreaCore, } from '@core-front/textarea';
import TextField from '@telia-front/textfield';
const TextArea = (props) => {
    function BEM() {
        const classArray = [];
        if (props.height) {
            classArray.push(`textarea--${props.height}`);
        }
        if (props.className) {
            classArray.push(props.className);
        }
        return classArray.join(' ');
    }
    return (React.createElement(TextAreaCore, Object.assign({}, props, { className: BEM(), components: {
            TextField,
        } })));
};
export default TextArea;
